import React, {lazy, Suspense} from 'react'

const CourseLandingPageLazy = lazy(() =>
    import('./CourseLandingPage')
)

const CourseLandingPage = props => (
    <Suspense fallback={null}>
        <CourseLandingPageLazy {...props} />
    </Suspense>
)

export default CourseLandingPage
